type AepBannerOneTextLineProps = {
  message: string;
};

export function AepBannerOneTextLine({ message }: AepBannerOneTextLineProps) {
  return (
    <div className="py-8-8 bg-gradient-to-r from-[#5A79BB] to-[#353C70] to-[60%] hc-typography--paragraph-sm text-gray-0 text-nowrap flex overflow-hidden w-full">
      <p className="animate-marquee tablet:animate-none w-fit px-8-8 tablet:mx-auto">
        {message}
      </p>
      <p className="animate-marquee tablet:animate-none tablet:hidden w-fit px-8-8">
        {message}
      </p>
    </div>
  );
}
